// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2mJyL","calendarButtons":"ClockData_calendarButtons__3P1a2"};